"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamname = void 0;
var TEAMNAME_PATTERN = /^[a-z][a-z0-9_]+$/;
exports.isTeamname = function (id) { return TEAMNAME_PATTERN.test(id); };
//# sourceMappingURL=teamname.js.map